import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterContador() {
  const { registerContador } = useAuth();
  const [form, setForm] = useState({ nombre: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const ch = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) return setError('Las contraseñas no coinciden');
    setLoading(true); setError('');
    try {
      await registerContador({ nombre: form.nombre, email: form.email, password: form.password });
      window.location.href = '/'; // el layout lo lleva al panel de contador
    } catch (err) {
      setError(err.response?.data?.error || 'Error al registrar');
    } finally { setLoading(false); }
  };

  return (
    <div style={S.container}>
      <div style={S.card}>
        <div style={S.header}>
          <div style={S.logo}>ERP</div>
          <h1 style={S.title}>Crear cuenta de contador</h1>
          <p style={S.subtitle}>Gestiona la contabilidad de todas tus empresas desde una sola cuenta.</p>
        </div>
        <form onSubmit={submit}>
          {error && <div style={S.error}>{error}</div>}
          <div style={S.field}><label style={S.label}>Tu nombre</label>
            <input style={S.input} name="nombre" value={form.nombre} onChange={ch} placeholder="Juan Pérez" required /></div>
          <div style={S.field}><label style={S.label}>Correo electrónico</label>
            <input style={S.input} type="email" name="email" value={form.email} onChange={ch} placeholder="contador@correo.com" required /></div>
          <div style={S.row}>
            <div style={S.field}><label style={S.label}>Contraseña</label>
              <input style={S.input} type="password" name="password" value={form.password} onChange={ch} required /></div>
            <div style={S.field}><label style={S.label}>Confirmar</label>
              <input style={S.input} type="password" name="confirmPassword" value={form.confirmPassword} onChange={ch} required /></div>
          </div>
          <button style={{ ...S.btn, opacity: loading ? .7 : 1 }} disabled={loading} type="submit">{loading ? 'Creando…' : 'Crear cuenta de contador'}</button>
          <p style={S.foot}>¿Ya tienes cuenta? <Link to="/login" style={S.link}>Inicia sesión</Link></p>
          <p style={S.foot}>¿Eres una empresa? <Link to="/register" style={S.link}>Registra tu empresa</Link></p>
        </form>
      </div>
    </div>
  );
}

const S = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a', padding: 16, fontFamily: 'system-ui,sans-serif' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 16, padding: 32, width: 440, maxWidth: '100%' },
  header: { textAlign: 'center', marginBottom: 20 },
  logo: { display: 'inline-block', background: '#3b82f6', color: '#fff', fontWeight: 800, borderRadius: 10, padding: '8px 14px', letterSpacing: 1 },
  title: { color: '#f1f5f9', fontSize: 22, fontWeight: 700, margin: '14px 0 2px' },
  subtitle: { color: '#64748b', fontSize: 13, margin: 0 },
  field: { flex: 1, marginBottom: 14, display: 'flex', flexDirection: 'column' },
  row: { display: 'flex', gap: 12 },
  label: { color: '#94a3b8', fontSize: 12, marginBottom: 5 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '10px 12px', color: '#f1f5f9', fontSize: 14 },
  btn: { width: '100%', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 10, padding: '12px 0', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 4 },
  error: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5', padding: '10px 12px', borderRadius: 8, marginBottom: 14, fontSize: 13 },
  foot: { textAlign: 'center', color: '#64748b', fontSize: 13, margin: '12px 0 0' },
  link: { color: '#3b82f6', textDecoration: 'none', fontWeight: 600 },
};
